const siteData = {
  siteName: "Horizon株式会社",
  tagline: "あなたのビジネスを次のステージへ",
  heroHeading: "テクノロジーで、未来を切り拓く",
  description: "私たちはDXを通じてお客様の事業変革を支援します。豊富な実績と専門知識で、ビジネスの成長を力強くサポートします。",
  features: [
    { title: "高品質なサービス", desc: "お客様のニーズに合わせた最高水準のサービスをご提供します" },
    { title: "迅速な対応", desc: "お問い合わせから24時間以内にご返答いたします" },
    { title: "充実したサポート", desc: "導入後も継続的なサポートで安心してご利用いただけます" },
  ],
  heroImage: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200",
  images: [
    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800",
    "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800",
    "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800",
  ],
  industry: "ITコンサルティング",
  address: "東京都渋谷区恵比寿1-2-3",
  hours: "平日 9:00〜18:00",
  cta: "お問い合わせ",
  color: "#1e3a5f",
  news: [
    { title: "新サービス「DX診断」の提供を開始しました", date: "2025.04.01" },
    { title: "導入事例ページを更新しました", date: "2025.03.15" },
    { title: "春のキャンペーンを実施しています", date: "2025.03.01" },
  ],
  plans: [
    { name: "ライト", price: "¥9,800/月" },
    { name: "スタンダード", price: "¥19,800/月" },
    { name: "プレミアム", price: "¥49,800/月" },
  ],
};

export default siteData;
